<cigna-status-badge
  [type]="statusType"
  [text]="ClaimStatus[status] || status"
  [size]="size"
  [hasIcon]="true"
></cigna-status-badge>
